<template>
  <a-input
    v-bind="$attrs.item"
    v-model="modelList[name]"
    @change="(e)=>findEvent({e})"
    @pressEnter="(e)=>findEvent({e})"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { Input } from "ant-design-vue";
import Vue from 'vue'
Vue.use(Input)
export default {
  mixins: [formMixin],
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
};
</script>
